import { gql } from "@apollo/client";

const PRODUCT = gql`
  query product($filter: FindOneProduct!) {
    product(filter: $filter) {
      __typename
      ... on Product {
        id
        name
        description
        price
        shine
        stock
        url_image
        ref_image
        favorite {
          id
          product_id
        }
      }
    }
  }
`;

const PRODUCTS = gql`
  query products($filter: FindManyProducts) {
    products(filter: $filter) {
      ... on Product {
        id
        name
        description
        price
        shine
        stock
        url_image
        ref_image
        favorite {
          id
          product_id
        }
      }
    }
  }
`;

const PRODUCTS_ADMIN = gql`
  query productsAdmin {
    productsAdmin {
      __typename
      ... on Product {
        id
        active
        catalog_number
        name
        description
        price
        stock
        shine
        collection_id
        url_image
        ref_image
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { PRODUCTS, PRODUCT, PRODUCTS_ADMIN };
